<template>
    <div>
        <nav class="navbar fixed-top navbar-expand-lg navbar-light bg-light-tr">
            <div class="container">
                <span class="navbar-brand">
                    <a href="#" @click.prevent="goBack()" class="nav-item"><icon icon="chevron-left"/> Back</a>
                </span>


                <div class=" navbar-collapse d-none">


                    <ul class="navbar-nav my-2 my-lg-0 mx-auto">
                        <li>
                            <h4 class="text-center pt-1">{{title}}</h4>
                        </li>
                    </ul>

                </div>

                <button class="navbar-toggler d-inline" @click="toggleNav()" type="button">
                    <span class="navbar-toggler-icon"></span>
                </button>

            </div>
        </nav>



    </div>
</template>

<script>


    import Icon from "../ui/Icon";


    export default {
        name: 'MessengerNavigation',
        props:['title'],
        data(){
            return {


            }
        },
        computed: {
            isLoggedIn(){
                return this.$store.state.user.isLoggedIn;
            }
        },
        created () {},
        methods: {
            toggleNav(){
                this.$bus.$emit('sidebar.toggle');
            },
            goBack(){
              this.$router.go(-1);
            }
        },
        components: {
            Icon
        }
    }
</script>

<style lang="sass" scoped>



    .bg-light-tr
        background-color: rgba(255,255,255,.9)

    .navbar-brand img
        height: 26px


</style>



// WEBPACK FOOTER //
// src/components/layout/MessengerNavigation.vue